import React, { useEffect, useState } from "react";
import { Box, Typography } from "@mui/material";
import { Document, Page, pdfjs } from 'react-pdf/dist/esm/entry.webpack';
import './PDFSignPreview.css';
import 'react-pdf/dist/esm/Page/AnnotationLayer.css';
import 'react-pdf/dist/esm/Page/TextLayer.css';
pdfjs.GlobalWorkerOptions.workerSrc = `https://unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.js`;
pdfjs.GlobalWorkerOptions.cMapUrl = `https://unpkg.com/pdfjs-dist@${pdfjs.version}/cmaps/`;
pdfjs.GlobalWorkerOptions.cMapPacked = true;
pdfjs.GlobalWorkerOptions.standardFontDataUrl = `https://unpkg.com/pdfjs-dist@${pdfjs.version}/standard_fonts/`;

const PDFSignPreview = (props) => {
    const [pageNumber, setPageNumber] = useState(1);
    const [numPages, setNumPages] = useState(0);
    const [file, setFile] = useState('');
    const [tagColor, setTagColor] = useState({});
    const [rasterImages, setRasterImages] = useState({});

    useEffect(() => {
        let arr = {};
        Object?.keys(props?.formData)?.map((list) => {
            props?.formData[list]?.map((item) => {
                if (!arr[list]) {
                    arr[list] = [item?.background]
                } else if (arr[list].indexOf(item.background) === -1) {
                    arr[list]?.push(item.background);
                }
            });
        })

        setTagColor(arr);
    }, [pageNumber, props?.formData]);

    useEffect(() => {
        setPageNumber(Number(props?.selectPageNumber));
        setFile(props?.file);
    }, [props?.file, props?.selectPageNumber]);

    const onDocumentLoadSuccess = async (numPages) => {
        setNumPages(numPages?.numPages);
    };

    const onPageHandler = (val) => {
        props.pageNumber(val);
        setPageNumber(val);
    };

    const rasterizePage = async (pageNum) => {
        try {
            if (!file) return;
            const blobUrl = URL.createObjectURL(file);
            const loadingTask = pdfjs.getDocument({
                url: blobUrl,
                cMapUrl: `https://unpkg.com/pdfjs-dist@${pdfjs.version}/cmaps/`,
                cMapPacked: true,
                standardFontDataUrl: `https://unpkg.com/pdfjs-dist@${pdfjs.version}/standard_fonts/`,
                useSystemFonts: true
            });
            const doc = await loadingTask.promise;
            const page = await doc.getPage(pageNum);
            const viewport1x = page.getViewport({ scale: 1 });
            const scaleFactor = 90 / viewport1x.width;
            const viewport = page.getViewport({ scale: scaleFactor });
            const canvas = document.createElement('canvas');
            const context = canvas.getContext('2d');
            const dpr = window.devicePixelRatio || 1;
            canvas.width = Math.floor(viewport.width * dpr);
            canvas.height = Math.floor(viewport.height * dpr);
            context.setTransform(dpr, 0, 0, dpr, 0, 0);
            await page.render({ canvasContext: context, viewport, intent: 'print' }).promise;
            const dataUrl = canvas.toDataURL('image/png');
            setRasterImages((prev) => ({ ...prev, [pageNum]: dataUrl }));
            URL.revokeObjectURL(blobUrl);
        } catch (e) {
            console.error('Rasterize preview failed', e);
        }
    };

    return (
        <Box className="sign-preview-wrapper" style={{ overflow: numPages > 3 ? 'auto' : 'hidden' }}>
            <Box className="sign-leftbar-container">
                {file && <Document
                    file={file}
                    options={{
                        cMapUrl: `https://unpkg.com/pdfjs-dist@${pdfjs.version}/cmaps/`,
                        cMapPacked: true,
                        standardFontDataUrl: `https://unpkg.com/pdfjs-dist@${pdfjs.version}/standard_fonts/`,
                        useSystemFonts: true
                    }}
                    onLoadSuccess={(num) => onDocumentLoadSuccess(num)}
                    onLoadError={(e) => console.error('PDF preview load error', e)}
                >
                    {Array.from({ length: numPages }, (_, index) => index + 1).map((pages, i) => (
                        <Box key={i} className='sign-pdf-preview-container'>
                            <Box className={i + 1 === pageNumber ? "sign-pdf-select-preview" : "sign-pdf-viewer-preview"}
                                onClick={() => onPageHandler(i + 1)}>
                                <Box className="sign-preview-body">
                                    {!rasterImages[pages] ? (
                                        <Page
                                            width={90}
                                            height={100}
                                            pageNumber={pages}
                                            renderTextLayer={true}
                                            renderAnnotationLayer={true}
                                            onRenderError={(e) => { console.error('Preview render error', e); rasterizePage(pages); }}
                                        />
                                    ) : (
                                        <img
                                            src={rasterImages[pages]}
                                            alt={`preview-page-${pages}`}
                                            style={{ width: 90, height: 100, objectFit: 'contain' }}
                                        />
                                    )}
                                    <Box className="sign-tag-container">
                                        {tagColor[pages]?.map((item, i) => {
                                            let color = 'var(--primary)';
                                            return (
                                                <Box className="sign-tag-body" key={i}>
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="23" height="8" viewBox="0 0 23 8" fill="none">
                                                        <path d="M0.0118625 3.99573L5.46361 0.541749L5.44307 7.46254L0.0118625 3.99573Z" fill={color} />
                                                        <rect x="5.60638" y="0.614746" width="25.3936" height="6.76201" fill={color} />
                                                    </svg>
                                                </Box>
                                            )
                                        })}
                                    </Box>
                                </Box>
                                <Typography className="sign-page-number">{i + 1}</Typography>
                            </Box>
                        </Box>
                    ))}
                </Document>}
            </Box>
        </Box>
    )
};

export default PDFSignPreview;